import angular from 'angular';
import { ITrabalhadorLocado } from '../models/trabalhadorlocado.model';
import { SituacaoLocadosEnum } from '../enums/situacaolocados.enum';
import { TrabalhadoresLocadosService } from '../trabalhadoreslocados.service';
import { HorariosService } from '../../Horarios/horarios.service';

export class TrabalhadorLocadoShowController implements angular.IController {
    static $inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$state',
        'TrabalhadoresLocadosService',
        'entity',
        'NewToaster',
        '$http',
        'nsjRouting',
        '$q',
        '$uibModal',
        'HorariosService',
    ];

    public form: angular.IFormController;
    public busy = false;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            nsjGlobals: any,
        },
        public $stateParams: angular.ui.IStateParamsService,
        public $state: angular.ui.IStateService,
        public entityService: TrabalhadoresLocadosService,
        public entity: ITrabalhadorLocado,
        public NewToaster: any,
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $q: angular.IQService,
        public $uibModal: any,
        public HorariosService: HorariosService,
    ) {}

    $onInit() {

        // buscar dados do horário
        if (this.entity.horario) {
            this.busy = true;

            this.HorariosService.get(this.entity.horario, true).then((horarioBuscado) => {
                this.entity.horarioExibicao = horarioBuscado.nomeHorarioDetalhado;
            })
            .catch((error) => {

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Não foi possível buscar informações do horário',
                    body: error.data.message
                });

                this.entity.horarioExibicao = null;
            })
            .finally(() => {
                this.busy = false;
            });

        }

    }

    public getSituacaoLabel(situacaoLocado: string) {
        return situacaoLocado === SituacaoLocadosEnum.ATIVO ? 'Ativo' : 'Inativo';
    }

}
